import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {Link, LinkIcon, GetStartedInput} from '../../components'
import container from '../../helpers/container'

import Styles from './About.css'

@CSSModules(Styles)
export default class About extends Component {
  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const title = 'About'
    const url = config.domain + config.routes.about

    const bannerImage = 'park'
    const bannerHeadline = 'About Gun Free Funds'
    const bannerSubtitle = 'You can invest your values'

    // const aysLogo = require( '../../../static/images/' )
    const iyvLogo = require( '../../../static/images/iyv-logo-project-of-2021.jpg' )

    return (
      <div>
        {container.helmet(title, '', url)}

        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>{bannerHeadline}</div>
                <div styleName='image-banner-subtitle'>{bannerSubtitle}</div>
              </div>
            </div>
          </div>
        </div>

        <div styleName='page'>

          <div styleName='container'>
            <div styleName='container-inner'>

              <div styleName='double-logo-wrap'>
                <div styleName='double-logo'>
                  <div styleName='logo-second-wrap'>
                    <Link
                      to={config.links.aysinvest}
                      title='Invest Your Values - a project of As You Sow'
                      >
                      <img
                        styleName={'logo-ays'}
                        src={iyvLogo}
                        alt='Invest Your Values - a project of As You Sow'
                      />
                    </Link>
                  </div>
                </div>
              </div>

              <div styleName='title'>
                You may be invested in gun manufacturers and gun retailers
              </div>
              <div styleName='lede'>
                You shouldn't have to be a financial expert to know how much of your savings are invested in unsustainable and morally problematic companies.
              </div>
              <div styleName='title'>
                Responsible investing made easy
              </div>
              <div styleName='lede'>
                Gun Free Funds enables you to find out if your money, in the form of individual mutual fund investments or an employer-provided 401(k), is being used to finance makers of assault rifles, handguns, shotguns, and other kinds of civilian firearms and ammunition, and to find alternative options that avoid gun investments.
              </div>
              <div styleName='lede'>
                We can help build a more peaceful world by reducing the power of those who profit from violence. Investors have the power to cut ties with the corporations that make and sell the tools of gun violence, and to reinvest in ethical companies that support our communities and protect our planet.
              </div>
              <div styleName='title'>
                Who we are
              </div>
              <div styleName='lede'>
                For over two decades, As You Sow has promoted aligning investing with values. As part of our <Link to={config.links.aysinvest} xstrong={true} title='As You Sow - Invest Your Values'>Invest Your Values program</Link>, we've created a series of tools that provide free information helping people align their investments with their values.
              </div>

              <div styleName='title'>
                How Gun Free Funds works
              </div>
              <div styleName='lede'>
                <ul>
                  <li>Look up mutual funds using up-to-date Morningstar data</li>
                  <li>We analyze your investments for gun manufacturer and retailer stocks</li>
                  <li>See each fund's gun investments grade</li>
                </ul>
                <p>
                  <Link
                    to={config.routes.howitworks}
                    xstrong={true}
                    title='How it works'>
                      See how it works<LinkIcon />
                  </Link>
                </p>
              </div>
              <div styleName='title'>
                Use our action toolkit
              </div>
              <div styleName='lede'>
                <ul>
                  <li>Learn how to make a change and invest gun free</li>
                  <li>Push your employer to provide gun free 401(k) options</li>
                </ul>
                <p>
                  <Link
                    to={config.routes.toolkit}
                    xstrong={true}
                    title='Action toolkit'>
                      View the action toolkit<LinkIcon />
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <GetStartedInput />

        </div>

      </div>
    )
  }
}
